import { FilterSchema } from '../../../../../core/base/interfaces/filter-schema.interface';
import { ContactTypeService } from '../../../settings/contact-type/contact-type.service';
import { EstablishmentService } from '../../establishment/establishment.service';
import { ActivityTypeService } from '../../../settings/activity-type/activity-type.service';

export const USER_PROFILE_FILTER_SCHEMA: FilterSchema = {
  lastName: { type: 'text' },
  firstName: { type: 'text' },
  contactType: { type: 'entity[]', resolve: { service: ContactTypeService, displayProperty: 'label' } },
  establishments: { type: 'entity[]', resolve: { service: EstablishmentService, displayProperty: 'label' } },
  activities: { type: 'entity[]', resolve: { service: ActivityTypeService, displayProperty: 'acronym' } },
};
